import { getFrontAndBackCardIndices } from "@/utils/animation";
$ const { duration = 400 } = input;

<div class="cast-intro-cards" key="container">
  $ const influencerCards = component.getInfluencerCards(input.cards);
  <evo-motion-value|value|
    value=state.index
    duration=duration
    easingFn="standard"
  >
    $ const frontCardOpacity = Math.abs(1 - (value % 2));
    $ const [frontIndex, backIndex] = getFrontAndBackCardIndices(
      state.index,
      influencerCards.length,
    );
    <cast-flip-card style=`--card-active-index: ${value}; --card-front-opacity: ${frontCardOpacity}`>
      <@front>
        <div class="cast-intro-cards__card">
          <card-sequence
            cards=influencerCards
            index=frontIndex
            imagesLoaded=state.imagesLoaded
          />
        </div>
      </@front>
      <@back>
        <div class="cast-intro-cards__card">
          <card-sequence
            cards=influencerCards
            index=backIndex
            imagesLoaded=state.imagesLoaded
          />
        </div>
      </@back>
    </cast-flip-card>
  </evo-motion-value>
  <evo-motion-value|value|
    value=state.productCardAnimatedValue
    duration=800
    delay=0
    easingFn="quickEnter"
  >
    <div class="cast-intro-cards__peekaboo" style=`--animation-value: ${value}`>
      <img src=(
        input.cards[state.index % input.cards.length].products[0].imageUrl
      )>
    </div>
    <div class="cast-intro-cards__peekaboo" style=`--animation-value: ${value}`>
      <img src=(
        input.cards[state.index % input.cards.length].products[1].imageUrl
      )>
    </div>
  </evo-motion-value>
</div>
